// =========================================================
// frontend/js/tree.js - V9.0 (Smooth UI, Editing & MinStaffing)
// =========================================================
window._secureTreeMemory = null;
window._isFetchingTree = false;
window.renderAdminTreeTab = function() {
    if (window._secureTreeMemory === null && window.currentUser && window.currentUser.companyId) {
        if (!window._isFetchingTree) {
            window._isFetchingTree = true;
            db.collection('companies').doc(window.currentUser.companyId).collection('settings').doc('structure').get().then((doc)=>{
                window._secureTreeMemory = doc.exists && Array.isArray(doc.data().tree) ? doc.data().tree : [];
                window.orgStructure = window._secureTreeMemory;
                window._isFetchingTree = false;
                if (typeof render === 'function') render();
            }).catch((err)=>{
                window._secureTreeMemory = [];
                window._isFetchingTree = false;
                if (typeof render === 'function') render();
            });
        }
        return `<div class="p-24 text-center text-slate-400 animate-pulse font-black uppercase tracking-widest text-xs">Lade Struktur...</div>`;
    }
    const structure = window._secureTreeMemory || [];
    return `
        <div class="p-6 border-b border-slate-100 flex justify-between items-center bg-white">
            <div>
                <h4 class="font-black text-slate-800 text-xl tracking-tight">Unternehmens-Struktur</h4>
                <p class="text-[10px] text-slate-400 font-bold uppercase tracking-widest mt-1">Management der Hierarchie & Besetzungsregeln</p>
            </div>
            <button onclick="window.openElementModal(null, null)" class="bg-blue-600 text-white px-6 py-3 rounded-2xl font-black text-xs uppercase tracking-widest hover:bg-black transition shadow-xl shadow-blue-100 flex items-center gap-2">
                <i data-lucide="plus" class="w-4 h-4"></i> Hauptebene
            </button>
        </div>
        
        <div class="p-8 bg-slate-50/50 min-h-[550px]">
            <div class="max-w-4xl mx-auto space-y-4">
                ${structure.length === 0 ? window.renderEmptyState() : structure.map((node)=>window.renderRecursiveNode(node, 0)).join('')}
            </div>
        </div>
        <div id="tree-modal-container"></div>
    `;
};
window.renderRecursiveNode = function(node, depth) {
    const indent = depth * 28;
    const hasChildren = node.children && node.children.length > 0;
    const iconMap = {
        'building': 'building-2',
        'unit': 'layers',
        'team': 'users',
        'project': 'briefcase',
        'default': 'circle'
    };
    const currentIcon = iconMap[node.type] || iconMap.default;
    // Badge für Mindestbesetzung
    let staffingBadge = '';
    if (node.minStaffing && node.minStaffing.enabled) {
        const isHard = node.minStaffing.type === 'hard';
        staffingBadge = `
            <div class="flex items-center gap-1.5 px-3 py-1 rounded-lg ${isHard ? 'bg-rose-50 text-rose-600 border border-rose-100' : 'bg-orange-50 text-orange-600 border border-orange-100'}">
                <i data-lucide="shield-alert" class="w-3 h-3"></i>
                <span class="text-[9px] font-black uppercase tracking-widest">Min. ${node.minStaffing.count} (${isHard ? 'Hart' : 'Weich'})</span>
            </div>
        `;
    }
    return `
        <div class="group/node relative">
            ${depth > 0 ? `<div class="absolute w-[2px] bg-slate-200" style="left: ${indent - 14}px; top: -16px; bottom: 50%;"></div><div class="absolute h-[2px] bg-slate-200" style="left: ${indent - 14}px; width: 14px; top: 50%;"></div>` : ''}
            
            <div class="flex items-center justify-between bg-white border border-slate-100 p-4 rounded-2xl hover:border-blue-300 hover:shadow-lg transition-all relative z-10" style="margin-left: ${indent}px">
                <div class="flex items-center gap-4">
                    <div class="w-10 h-10 flex items-center justify-center rounded-xl ${hasChildren ? 'bg-blue-600 text-white shadow-md' : 'bg-slate-100 text-slate-500'}">
                        <i data-lucide="${currentIcon}" class="w-5 h-5"></i>
                    </div>
                    <div>
                        <div class="flex items-center gap-3">
                            <span onclick="window.selectTreeNode('${node.id}')" class="font-black text-slate-800 text-base cursor-pointer hover:text-blue-600 transition-colors">${node.name}</span>
                            ${staffingBadge}
                        </div>
                        <span class="text-[9px] font-black text-slate-400 uppercase tracking-tighter">${node.type || 'Ebene'}</span>
                    </div>
                </div>
                
                <div class="flex items-center gap-1 opacity-0 group-hover/node:opacity-100 transition-opacity bg-white pl-4">
                    <button onclick="window.openElementModal('${node.id}', null)" class="p-2.5 text-blue-600 hover:bg-blue-50 rounded-xl transition-colors" title="Unterelement hinzuf\xfcgen"><i data-lucide="plus-circle" class="w-4 h-4"></i></button>
                    <button onclick="window.openElementModal(null, '${node.id}')" class="p-2.5 text-emerald-600 hover:bg-emerald-50 rounded-xl transition-colors" title="Bearbeiten"><i data-lucide="edit-2" class="w-4 h-4"></i></button>
                    <button onclick="window.deleteElement('${node.id}')" class="p-2.5 text-rose-500 hover:bg-rose-50 rounded-xl transition-colors" title="L\xf6schen"><i data-lucide="trash-2" class="w-4 h-4"></i></button>
                </div>
            </div>
            
            ${hasChildren ? `<div class="mt-3 relative">${node.children.map((child)=>window.renderRecursiveNode(child, depth + 1)).join('')}</div>` : ''}
        </div>
    `;
};
// Hilfsfunktion: Findet eine Node im Baum
window.findNodeRecursive = function(list, id) {
    for (let item of list){
        if (item.id === id) return item;
        if (item.children) {
            let found = window.findNodeRecursive(item.children, id);
            if (found) return found;
        }
    }
    return null;
};
// Kombiniertes Modal für Hinzufügen & Bearbeiten
window.openElementModal = function(parentId = null, editNodeId = null) {
    const container = document.getElementById('tree-modal-container');
    if (!container) return;
    window.currentParentId = parentId;
    window.currentEditNodeId = editNodeId;
    let existingNode = null;
    if (editNodeId) existingNode = window.findNodeRecursive(window._secureTreeMemory, editNodeId);
    window.tempSelectedType = existingNode ? existingNode.type : 'building';
    const isStaffingEnabled = existingNode?.minStaffing?.enabled || false;
    container.innerHTML = `
        <div class="fixed inset-0 bg-slate-900/60 backdrop-blur-sm z-[200] flex items-center justify-center p-4 animate-fadeIn">
            <div class="bg-white rounded-[3rem] shadow-2xl w-full max-w-lg flex flex-col max-h-[90vh]">
                
                <div class="p-8 border-b border-slate-100 flex items-center gap-4 bg-slate-50/50 rounded-t-[3rem]">
                    <div class="w-12 h-12 ${existingNode ? 'bg-emerald-100 text-emerald-600' : 'bg-blue-100 text-blue-600'} rounded-2xl flex items-center justify-center">
                        <i data-lucide="${existingNode ? 'edit-3' : 'folder-plus'}" class="w-6 h-6"></i>
                    </div>
                    <div>
                        <h3 class="text-2xl font-black text-slate-800 tracking-tight">${existingNode ? 'Element bearbeiten' : 'Neues Element'}</h3>
                        <p class="text-[10px] font-bold text-slate-400 uppercase tracking-widest mt-1">Struktur & Regeln definieren</p>
                    </div>
                </div>

                <div class="p-8 overflow-y-auto space-y-8">
                    <div>
                        <label class="block text-[10px] font-black text-slate-400 uppercase tracking-widest mb-3 ml-1">Bezeichnung</label>
                        <input type="text" id="new-node-name" value="${existingNode ? existingNode.name : ''}" autofocus placeholder="z.B. Frontend Team..." class="w-full bg-slate-50 border border-slate-200 rounded-2xl px-6 py-4 font-bold text-slate-700 outline-none focus:border-blue-500 transition-all shadow-sm">
                    </div>
                    
                    <div>
                        <label class="block text-[10px] font-black text-slate-400 uppercase tracking-widest mb-3 ml-1">Typ w\xe4hlen</label>
                        <div class="grid grid-cols-4 gap-2">
                            ${window.renderTypeOption('building', 'Standort', 'building-2')}
                            ${window.renderTypeOption('unit', 'Abteilung', 'layers')}
                            ${window.renderTypeOption('team', 'Team', 'users')}
                            ${window.renderTypeOption('project', 'Projekt', 'briefcase')}
                        </div>
                    </div>

                    <div class="bg-orange-50/50 border border-orange-100 rounded-[2rem] p-6">
                        <div class="flex items-center justify-between mb-2">
                            <div>
                                <h4 class="text-sm font-black text-orange-800 flex items-center gap-2"><i data-lucide="shield-check" class="w-4 h-4"></i> Mindestbesetzung</h4>
                                <p class="text-[9px] font-bold text-orange-600/70 uppercase tracking-widest mt-1">Anwesenheitspflicht f\xfcr diese Ebene</p>
                            </div>
                            <label class="relative inline-flex items-center cursor-pointer">
                                <input type="checkbox" id="min-staffing-toggle" class="sr-only peer" ${isStaffingEnabled ? 'checked' : ''} onchange="window.toggleMinStaffingInputs(this.checked)">
                                <div class="w-11 h-6 bg-slate-200 peer-focus:outline-none rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-slate-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-orange-500"></div>
                            </label>
                        </div>
                        
                        <div id="min-staffing-details" class="${isStaffingEnabled ? '' : 'hidden'} mt-6 pt-4 border-t border-orange-200/50 grid grid-cols-2 gap-4">
                            <div>
                                <label class="block text-[10px] font-black text-orange-800 uppercase tracking-widest mb-2 ml-1">Personen</label>
                                <input type="number" id="min-staffing-count" min="1" value="${existingNode?.minStaffing?.count || 1}" class="w-full bg-white border border-orange-200 rounded-xl px-4 py-3 font-bold text-slate-700 outline-none focus:border-orange-500 shadow-sm">
                            </div>
                            <div>
                                <label class="block text-[10px] font-black text-orange-800 uppercase tracking-widest mb-2 ml-1">Regel-Typ</label>
                                <select id="min-staffing-type" class="w-full bg-white border border-orange-200 rounded-xl px-4 py-3 font-bold text-slate-700 outline-none focus:border-orange-500 shadow-sm">
                                    <option value="soft" ${existingNode?.minStaffing?.type === 'soft' ? 'selected' : ''}>Weich (Warnung)</option>
                                    <option value="hard" ${existingNode?.minStaffing?.type === 'hard' ? 'selected' : ''}>Hart (Blockiert)</option>
                                </select>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="p-8 border-t border-slate-100 flex gap-4 bg-white rounded-b-[3rem]">
                    <button onclick="document.getElementById('tree-modal-container').innerHTML=''" class="flex-1 py-4 bg-slate-100 text-slate-500 hover:bg-slate-200 rounded-2xl font-black uppercase tracking-widest text-xs transition-all">Abbrechen</button>
                    <button onclick="window.saveElementConfirm()" class="flex-[1.5] ${existingNode ? 'bg-emerald-600 hover:bg-emerald-700 shadow-emerald-100' : 'bg-blue-600 hover:bg-black shadow-blue-100'} text-white py-4 rounded-2xl font-black uppercase tracking-widest text-xs shadow-xl transition-all">
                        ${existingNode ? 'Speichern' : 'Erstellen'}
                    </button>
                </div>
            </div>
        </div>
    `;
    if (window.lucide) lucide.createIcons();
};
window.toggleMinStaffingInputs = function(isActive) {
    const details = document.getElementById('min-staffing-details');
    if (isActive) details.classList.remove('hidden');
    else details.classList.add('hidden');
};
window.renderTypeOption = function(type, label, icon) {
    const isActive = window.tempSelectedType === type;
    return `<button onclick="window.selectType(this, '${type}')" class="type-select-btn p-3 rounded-xl border transition-all flex flex-col items-center justify-center gap-2 ${isActive ? 'border-blue-600 bg-blue-50 text-blue-600' : 'border-slate-200 text-slate-400 hover:border-slate-300'}"><i data-lucide="${icon}" class="w-5 h-5"></i><span class="text-[9px] font-black uppercase tracking-tighter">${label}</span></button>`;
};
window.selectType = function(btn, type) {
    document.querySelectorAll('.type-select-btn').forEach((b)=>{
        b.classList.remove('border-blue-600', 'bg-blue-50', 'text-blue-600');
        b.classList.add('border-slate-200', 'text-slate-400');
    });
    btn.classList.add('border-blue-600', 'bg-blue-50', 'text-blue-600');
    window.tempSelectedType = type;
};
/**
 * SPEICHERN & LÖSCHEN
 */ window.saveElementConfirm = async function() {
    const name = document.getElementById('new-node-name').value.trim();
    if (!name) return alert("Bitte einen Namen angeben.");
    // Werte für Mindestbesetzung auslesen
    const minStaffingEnabled = document.getElementById('min-staffing-toggle').checked;
    const minStaffing = {
        enabled: minStaffingEnabled,
        count: parseInt(document.getElementById('min-staffing-count').value) || 1,
        type: document.getElementById('min-staffing-type').value || 'soft'
    };
    let currentStructure = JSON.parse(JSON.stringify(window._secureTreeMemory || []));
    // UPDATE MODUS
    if (window.currentEditNodeId) window.updateRecursive(currentStructure, window.currentEditNodeId, name, window.tempSelectedType, minStaffing);
    else {
        const newElement = {
            id: 'node_' + Date.now(),
            name: name,
            type: window.tempSelectedType || 'building',
            minStaffing: minStaffing,
            children: []
        };
        if (!window.currentParentId || window.currentParentId === 'null') currentStructure.push(newElement);
        else window.addRecursive(currentStructure, window.currentParentId, newElement);
    }
    try {
        await window.saveOrgStructureToCloud(window.currentUser.companyId, currentStructure);
        window._secureTreeMemory = currentStructure;
        window.orgStructure = currentStructure;
        document.getElementById('tree-modal-container').innerHTML = '';
        if (typeof render === 'function') render();
    } catch (e) {
        alert("Fehler beim Speichern: " + e.message);
    }
};
window.updateRecursive = function(list, id, newName, newType, newMinStaffing) {
    for (let item of list){
        if (item.id === id) {
            item.name = newName;
            item.type = newType;
            item.minStaffing = newMinStaffing;
            return true;
        }
        if (item.children && window.updateRecursive(item.children, id, newName, newType, newMinStaffing)) return true;
    }
    return false;
};
// ... Die restlichen Helper (deleteElement, deleteRecursive, getFlattenedTree, renderEmptyState) bleiben wie in deinem V8 Code.
window.deleteElement = async function(id) {
    if (!confirm("Wirklich l\xf6schen?")) return;
    let currentStructure = JSON.parse(JSON.stringify(window._secureTreeMemory || []));
    currentStructure = window.deleteRecursive(currentStructure, id);
    try {
        await window.saveOrgStructureToCloud(window.currentUser.companyId, currentStructure);
        window._secureTreeMemory = currentStructure;
        window.orgStructure = currentStructure;
        if (typeof render === 'function') render();
    } catch (e) {
        alert("Fehler beim L\xf6schen: " + e.message);
    }
};
window.addRecursive = function(list, parentId, newElement) {
    for (let item of list){
        if (item.id === parentId) {
            if (!item.children) item.children = [];
            item.children.push(newElement);
            return true;
        }
        if (item.children && item.children.length > 0) {
            if (window.addRecursive(item.children, parentId, newElement)) return true;
        }
    }
    return false;
};
window.deleteRecursive = function(list, id) {
    return list.filter((item)=>{
        if (item.id === id) return false;
        if (item.children) item.children = window.deleteRecursive(item.children, id);
        return true;
    });
};
window.getFlattenedTree = function(nodes, prefix = '') {
    let flat = [];
    if (!nodes) return flat;
    nodes.forEach((node)=>{
        flat.push({
            id: node.id,
            name: prefix + node.name
        });
        if (node.children && node.children.length > 0) flat = flat.concat(window.getFlattenedTree(node.children, prefix + node.name + ' > '));
    });
    return flat;
};
window.renderEmptyState = function() {
    return `
        <div class="flex flex-col items-center justify-center py-24 text-slate-300 bg-white rounded-[3rem] border-4 border-dashed border-slate-50 shadow-sm">
            <div class="w-24 h-24 bg-slate-50 rounded-full flex items-center justify-center mb-6">
                <i data-lucide="network" class="w-12 h-12 opacity-20"></i>
            </div>
            <p class="font-black text-slate-400 uppercase tracking-widest text-sm">Keine Struktur vorhanden</p>
            <button onclick="window.openElementModal(null, null)" class="mt-6 bg-slate-800 text-white px-8 py-4 rounded-2xl font-black text-[10px] uppercase tracking-widest hover:bg-black transition shadow-xl">
                Ersten Standort anlegen
            </button>
        </div>
    `;
};

//# sourceMappingURL=frontend.334ac072.js.map
